import React from 'react';

const SOURCE_LABELS: Record<string, { label: string; color: string }> = {
  // Données fondamentales
  fundamentals:                 { label: 'Fondamentaux',      color: '#3B82F6' },
  // Valorisation
  valuation_cache:              { label: 'Valorisation',      color: '#8B5CF6' },
  // Technique
  stock_daily_cache:            { label: 'Technique',         color: '#F59E0B' },
  market_cache:                 { label: 'Technique',         color: '#F59E0B' },
  technical_alerts:             { label: 'Alertes',           color: '#EF4444' },
  // Marché
  market_summary_cache:         { label: 'Mood Marché',      color: '#10B981' },
  market_rankings:              { label: 'Classements',       color: '#06B6D4' },
  daily_market_briefings:       { label: 'Flash Marché',     color: '#22C55E' },
  // Sociétés & Macro
  societes:                     { label: 'Profil Société',   color: '#64748B' },
  ai_summaries:                 { label: 'Analyse IA',        color: '#A855F7' },
  stock_commodity_correlations: { label: 'Matières Premières', color: '#D97706' },
  // Éducation
  educational_content:          { label: 'Lexique',           color: '#0EA5E9' },
  // Legacy
  cotations_actions:            { label: 'Cotations',         color: '#10B981' },
};

interface SourceBadgeProps {
  source: string;
}

export const SourceBadge: React.FC<SourceBadgeProps> = ({ source }) => {
  const info = SOURCE_LABELS[source] || { label: source, color: '#6B7280' };

  return (
    <span 
      className="source-badge"
      style={{ 
        color: info.color, 
        backgroundColor: `${info.color}26`, // 15% opacity in hex
        border: `1px solid ${info.color}40`,
        margin: '0 4px 4px 0',
        display: 'inline-block'
      }}
    >
      {info.label}
    </span>
  );
};
